import { LuPlug, LuRefreshCcw, LuTrash } from 'react-icons/lu';

import { Button } from '_components/_core';

const BancoInterActions = ({ values, handlePerformAction }) => {
  return (
    <>
      <Button
        variant="white"
        onClick={() => handlePerformAction('TEST_CONNECTION', values)}
        className="d-flex align-items-center justify-content-center"
      >
        Testar Conexão
        <LuPlug className="ml-2" />
      </Button>
      <Button
        variant="white"
        onClick={() => handlePerformAction('VIEW_WEBHOOKS', values)}
        className="d-flex align-items-center justify-content-center"
      >
        Ver Webhooks
        <LuPlug className="ml-2" />
      </Button>
      <Button
        variant="white"
        onClick={() => handlePerformAction('VIEW_WEBHOOK_EVENTS', values)}
        className="d-flex align-items-center justify-content-center"
      >
        Ver Eventos de Webhooks
        <LuPlug className="ml-2" />
      </Button>
      <Button
        variant="white"
        onClick={() => handlePerformAction('DELETE_WEBHOOKS', values)}
        className="d-flex align-items-center justify-content-center"
      >
        Excluir Webhooks
        <LuTrash className="ml-2" />
      </Button>
      <Button
        variant="white"
        onClick={() => handlePerformAction('SYNC_CHARGES', values)}
        className="d-flex align-items-center justify-content-center"
      >
        Sincronizar Cobranças
        <LuRefreshCcw className="ml-2" />
      </Button>
    </>
  );
};

export default BancoInterActions;
